import { faUserTimes } from "@fortawesome/free-solid-svg-icons";
import React, { useState } from "react";
import LegalPageLayout from "../Components/LegalPageLayout";

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY_CB, //"AIzaSyDBR-W77WeAi-fSbuNeYQfaXHsLwU8KMCM",
  authDomain: process.env.REACT_APP_AUTH_DOMAIN_CB, //"milesoft-cashbook.firebaseapp.com",
  projectId: process.env.REACT_APP_PROJECT_ID_CB, //"milesoft-cashbook",
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET_CB, //"milesoft-cashbook.appspot.com",
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID_CB, //"587751235188",
  appId: process.env.REACT_APP_APP_ID_CB, //"1:587751235188:web:af79faa5448d008bb03b21"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getDatabase(app);

function DeleteAccountCB() {
  const [data, setData] = useState({});
  const [user, setUser] = useState(auth.currentUser);
  const [transactions, setTransactions] = useState([]);
  const loadData = function (userId) {
    db.collection("data")
      .doc(userId)
      .collection("transactions")
      .get()
      .then((snapshot) => {
        var t = [];
        snapshot.forEach((doc) => {
          t.push(doc.data());
        });
        setTransactions(t);
      });
  };
  const handleChange = function (e) {
    setData({
      ...data,
      [e.target.id]: e.target.value,
    });
  };
  const handleSignIn = function (e) {
    e.preventDefault();
    auth
      .signInWithEmailAndPassword(data.email, data.password)
      .then((result) => {
        setUser(result.user);
        loadData(result.user.uid);
      });
  };
  const handleSignOut = function (e) {
    auth.signOut();
    setUser(null);
  };
  const handleDelete = function (e) {
    e.preventDefault();
    db.collection("data")
      .doc(user.uid)
      .collection("transactions")
      .get()
      .then(async (snapshot) => {
        //console.log("start deleting...")
        const batch = db.batch();
        snapshot.forEach((doc) => {
          //console.log(doc.data())
          batch.delete(doc.ref);
        });
        await batch.commit();
        //console.log("done deleting.");
        handleSignOut();
      });
  };
  return (
    <LegalPageLayout
      titleId="delete-cb-title"
      icon={faUserTimes}
      iconVariant="danger"
      title="Delete Account (CashBook)"
      description={
        <p>
          Sign in with the CashBook account you want to delete, review the
          account data count, then confirm the destructive action.
        </p>
      }
    >
            {user ? (
              <div>
                <p>
                  Hello {user.displayName}. You have {transactions.length}{" "}
                  transactions in your account. Please confirm deletion.
                </p>
                <div className="legal-actions">
                  <input
                    type="button"
                    className="btn-ms btn-ms-secondary btn-ms-md"
                    defaultValue={"Don't Delete"}
                    aria-label="Cancel account deletion and sign out"
                    onClick={handleSignOut}
                  />
                  <input
                    type="button"
                    className="btn-ms btn-ms-danger btn-ms-md"
                    defaultValue={"Delete Data"}
                    aria-label="Permanently delete CashBook account data"
                    onClick={handleDelete}
                  />
                </div>
              </div>
            ) : (
              <div>
                <p>
                  Please login to delete your account data from the CashBook
                  mobile app.
                </p>
                <form>
                  <div className="form-row">
                    <div className="form-col form-group">
                      <label className="form-label" htmlFor="email">Email</label>
                      <input
                        type="email"
                        id="email"
                        onChange={handleChange}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-col form-group">
                      <label className="form-label" htmlFor="password">Password</label>
                      <input
                        type="password"
                        id="password"
                        onChange={handleChange}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="legal-actions">
                    <input
                      type="button"
                      onClick={handleSignIn}
                      defaultValue="Sign In and Delete"
                      aria-label="Sign in before deleting CashBook account data"
                      className="btn-ms btn-ms-danger btn-ms-md"
                    />
                  </div>
                </form>
              </div>
            )}
    </LegalPageLayout>
  );
}

export default DeleteAccountCB;
